import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput, BooleanInput} from 'react-admin';
import {useTranslation} from "react-i18next";
import SidSelect from "./SidSelect";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <SidSelect/>
            <BooleanInput source="isData" label={t('admin.isData')} defaultValue={false}/>
        </CreateGuesser>
    )
}

export default Create
